import * as React from 'react';
import { SetupGuideContext, Step } from 'common/onboarding/immersive-onboarding-legacy/types';
import { Content, Header } from 'common/onboarding/immersive-onboarding-legacy/components';
import rocketImg from 'common/onboarding/immersive-onboarding-legacy/assets/rocket.svg';
import { useTranslation } from 'common/i18n/hooks';
import { WelcomeWithPlannedEvents } from './v2/welcome-with-plan';
import { WelcomeV2Default } from './v2/welcome-v2-default';
export const WelcomePhase2 = () => {
  const {
    t
  } = useTranslation();
  const {
    setupGuideInfo,
    completed
  } = React.useContext(SetupGuideContext);
  const {
    stepsCompleted
  } = setupGuideInfo;
  const hasPlannedEvents = stepsCompleted.has(Step.Events);
  return <>
      <Header title={t("onboarding-legacy.welcome.start-here")} step={t("onboarding-legacy.welcome.step-one")} imgSrc={rocketImg} duration={3} completed={completed[Step.Welcome]} data-sentry-element="Header" data-sentry-source-file="welcome.tsx" />
      <Content data-sentry-element="Content" data-sentry-source-file="welcome.tsx">{hasPlannedEvents ? <WelcomeWithPlannedEvents /> : <WelcomeV2Default />}</Content>
    </>;
};